import { REQUIRED_CLIENT_SIDE_COOKIES, validateCookies } from "@/utils/cookies";
import ErrorPage from "@/views/error/ErrorPage";
import { ReactNode } from "react"
import { useTranslation } from "react-i18next";

interface AppGuardProps {
    children: ReactNode;
    cookies?: string[];
}

export const AppGuard = ({ children, cookies = REQUIRED_CLIENT_SIDE_COOKIES }: AppGuardProps) => {
    const { t } = useTranslation();
    const isCookiesValid = validateCookies(cookies);

    if (!isCookiesValid) {
        return <ErrorPage message={t('sessionExpired')} />;
    }

    return children;
}
